import React from 'react';
import { useAppSelector } from 'store/hooks';
import { ApplicationState } from 'store/store';
import { filterTemplates } from 'components/perks/templates/filterTemplates';

export const usePerkTemplatesData = () => {
    const { templates, loading } = useAppSelector((state: ApplicationState) => state.perkTemplates);
    const [searchValue, setSearchValue] = React.useState('');

    const handleSearchChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchValue(e.target.value);
    }, []);

    const handleClearSearch = React.useCallback(() => {
        setSearchValue('');
    }, []);

    const userTemplates = React.useMemo(() => templates.filter(t => !!t.tenantId), [templates]);
    const suggestedTemplates = React.useMemo(() => templates.filter(t => !t.tenantId), [templates]);

    const filteredUserTemplates = React.useMemo(
        () => filterTemplates(userTemplates, searchValue),
        [userTemplates, searchValue]
    );

    const filteredSuggestedTemplates = React.useMemo(
        () => filterTemplates(suggestedTemplates, searchValue),
        [suggestedTemplates, searchValue]
    );

    return {
        templates,
        loading,
        searchValue,
        filteredUserTemplates,
        filteredSuggestedTemplates,
        handleSearchChange,
        handleClearSearch
    };
};
